import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SecurityCheck from './components/SecurityCheck';
import Header from './components/Header';
import Footer from './components/Footer';
import WalletModal from './components/WalletModal';
import { WalletModalProvider } from './context/WalletModalContext';
import Home from './pages/Home';
import ProfileModal from './components/ProfileModal';

function App() {
  return (
    <SecurityCheck>
      <WalletModalProvider>
        <BrowserRouter>
          <Header />
          <main style={{ paddingTop: 64 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ProfileModal" element={<ProfileModal />} />
            </Routes>
          </main>
          <Footer />
          <WalletModal />
        </BrowserRouter>
      </WalletModalProvider>
    </SecurityCheck>
  );
}

export default App;